import React, { useState } from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import EditorHelpIcon from '@atlaskit/icon/core/question-circle';
import { token } from '@atlaskit/tokens';
import type { priority_softwareReleasesVersionDetailIssueList$key } from './__generated__/priority_softwareReleasesVersionDetailIssueList.graphql';

type Props = {
	jiraPriorityField: priority_softwareReleasesVersionDetailIssueList$key;
};

export const Priority = ({ jiraPriorityField }: Props): React.JSX.Element => {
	const [isPriorityIconBroken, setIsPriorityIconBroken] = useState<boolean>(false);

	const { priority } = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment priority_softwareReleasesVersionDetailIssueList on JiraPriorityField {
				priority {
					name
					iconUrl @required(action: NONE)
				}
			}
		`,
		jiraPriorityField,
	);

	return (
		<PriorityContainer>
			{priority &&
				(isPriorityIconBroken ? (
					<EditorHelpIcon label={priority.name || ''} />
				) : (
					<Icon
						src={priority.iconUrl}
						alt={priority.name ?? undefined}
						title={priority.name ?? undefined}
						onError={() => {
							setIsPriorityIconBroken(true);
						}}
					/>
				))}
		</PriorityContainer>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Icon = styled.img({
	height: '16px',
	width: '16px',
	marginTop: 0,
	marginRight: token('space.050'),
	marginBottom: 0,
	marginLeft: 0,
	flex: '0 0 auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PriorityContainer = styled.div({
	width: '16px',
	minWidth: '16px',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
});
